import { render, staticRenderFns } from "./CoachScoutingReportsSummary.vue?vue&type=template&id=1830dc84&scoped=true&"
import script from "./CoachScoutingReportsSummary.vue?vue&type=script&lang=ts&"
export * from "./CoachScoutingReportsSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830dc84",
  null
  
)

export default component.exports